import React, {useEffect} from 'react';
import {Form, InputGroup} from 'react-bootstrap';
import {useJobContext} from 'contexts';
import {
    PartialProduct,
    ProductType,
    useProductQuantity,
} from 'components/customer/JobDashboard/helpers/useProductQuantity';
import {PartialJob} from 'shared/types/PartialJob';
import {Icon} from 'shared/helpers';
import styled from 'styled-components';
import {useAppDispatch} from 'store/customer';
import {addChange, removeChange, Type} from 'store/customer/appSlice';

interface ProductQuantityType {
    value: number;
    productDetails: Partial<PartialProduct>;
    type?: ProductType;
}

export const ProductQuantity = ({
    value,
    productDetails,
    type = ProductType.PRODUCT,
}: ProductQuantityType) => {
    const dispatch = useAppDispatch();
    const {
        quantity,
        decreaseQuantity,
        increaseQuantity,
        updateQuantity,
        updateProduct,
    } = useProductQuantity(value, productDetails, type);
    const {job} = useJobContext() as PartialJob;

    useEffect(() => {
        if (value != quantity) {
            dispatch(
                addChange({id: productDetails.id, type: Type.PRODUCT_QUANTITY})
            );
        } else {
            dispatch(
                removeChange({
                    id: productDetails.id,
                    type: Type.PRODUCT_QUANTITY,
                })
            );
        }
    }, [quantity, value]);

    return (
        <Container>
            <Button
                data-cy="decrease-quantity"
                iconName="Button-Minus.svg"
                style={{opacity: quantity == 1 ? 0.5 : 1}}
                onClick={decreaseQuantity}
                color="secondary"
            />
            <Number
                data-no-drag
                data-cy="quantity"
                type="number"
                name="product"
                value={quantity}
                onChange={updateQuantity}
            />
            <Button
                data-cy="increase-quantity"
                iconName="Button-Plus.svg"
                onClick={increaseQuantity}
                color="secondary"
            />
            <Button
                data-cy="save-quantity"
                disabled={
                    typeof quantity === 'undefined' ||
                    value == quantity ||
                    job.status == 5
                }
                iconName="Button-Tick-Secondary.svg"
                onClick={updateProduct}
                color="primary"
            />
        </Container>
    );
};

const Number = styled(Form.Control)`
    text-align: center;
    border: 1px solid ${({theme}) => theme.colors.primary.main};
    font-weight: normal;
    border-radius: 8px !important;
    max-width: 60px;
    height: 28px;
    box-shadow: 2px 2px ${({theme}) => theme.colors.primary.main};
    font-size: 1em;
    padding: 6px 2px;
    min-width: 15px !important;
`;

const Button = styled(Icon)`
    width: 18px;
    cursor: pointer;
`;

const Container = styled(InputGroup)`
    gap: 5px;
    justify-content: center;
`;
